
// Export all functions from queries
export * from './queries';
export * from './type-guards';
export * from './database-helpers';
// Export mutations with different names to avoid conflicts
export { 
  safeUpdate as updateRecord, 
  safeDelete as deleteRecord, 
  safeBulkInsert as bulkInsertRecords,
  safeUpdate,
  safeDelete
} from './mutations';

// Export utility functions
export const toUUID = (value: any): string => {
  if (typeof value === 'string') {
    return value;
  }
  return String(value);
};
